import { cva, type VariantProps } from 'class-variance-authority';
import type * as React from 'react';

import { cn } from '@plato/ui/util/classes';

const badgeVariants = cva(
    'inline-flex items-center rounded-md border px-2.5 py-0.5 text-sm font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2',
    {
        variants: {
            variant: {
                // legacy shadcn variants — kept for backward compatibility
                default: 'border-transparent bg-neutral-800 text-white shadow-sm hover:bg-neutral-700',
                secondary: 'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
                destructive:
                    'border-transparent bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/80',
                outline: 'text-foreground',
                // semantic variants
                positive: 'border-green-300 bg-green-50 text-green-600',
                warning: 'border-red-300 bg-red-50 text-red-600',
                intermediate: 'border-orange-300 bg-orange-50 text-orange-600',
                neutral: 'border-neutral-300 bg-neutral-50 text-neutral-600',
                blue: 'border-blue-300 bg-blue-50 text-blue-600',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    },
);

export type BadgeProps = {} & React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof badgeVariants>;

function Badge({ className, variant, ...props }: BadgeProps) {
    return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
